import { h } from "preact";
import { RoutableProps } from "preact-router";
import "./styles.scss";
import { Snackbar, SnackbarShowCommand } from "../../../components/Snackbar";
import { useCommand } from "../../../hooks";
import { manufacturingConfigurations } from "../../../App";
import { mezosSIT } from "../../../data/serialNumberSearchExecs";
import { ProductLabelReprint } from "../../../components/ProductLabelReprint";

export function MezosSITReprint(props: RoutableProps) {
    const showSnackbar = useCommand<SnackbarShowCommand>();

    return (
        <div class="mezos-sit-reprint-page">
            <Snackbar doShow={showSnackbar} />
            <ProductLabelReprint
                showSnackbar={showSnackbar}
                configurations={manufacturingConfigurations["MezosSIT"]}
                execs={[mezosSIT.execs.elementSerialRegexPlain]}
                scanExecs={mezosSIT.orderedExecs}
            />
        </div>
    );
}
